import { styled, TextField } from "@mui/material";

export const StyledInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    maxHeight: 200,
    padding: "10px",
    lineHeight: "14px !important",
    overflowY: "scroll !important",
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
    "&::-webkit-scrollbar": {
      width: "0",
    },
  },
  "& .MuiInputBase-root": {
    padding: "7px 0px",
  },
}));
